export default "__VITE_ASSET__Baou$FCJ__"